import React from 'react';
   
const Dashboard = React.lazy(() => import('./views/dashboard/Dashboards'));
const DashboardSimple = React.lazy(() => import('./views/dashboard/DashboardSimple'));
const CoreUIIcons = React.lazy(() => import('./views/icons/coreui-icons/CoreUIIcons'));
const Flags = React.lazy(() => import('./views/icons/flags/Flags'));
const Brands = React.lazy(() => import('./views/icons/brands/Brands'));
 
const Colors = React.lazy(() => import('./views/theme/colors/Colors'));
const Typography = React.lazy(() => import('./views/theme/typography/Typography'));  
const ledger = React.lazy(() => import('./views/pages/Dani/ledger'));  
const itemList = React.lazy(() => import('./views/pages/Dani/itemList'));  
const saleo = React.lazy(() => import('./views/pages/Dani/saleo'));  
const Order = React.lazy(() => import('./views/pages/FFood/Orderf'));  
const saleList = React.lazy(() => import('./views/pages/Dani/saleList'));  
const ItemDef = React.lazy(() => import('./views/pages/Dani/ItemDef'));  
 const routes = [
  { path: '/', exact: true, name: 'Home' ,id:0},
  { path: '/dashboard', name: 'Dashboard', component: Dashboard ,id:4},
  { path: '/Ledger', name: 'ledger', component: ledger ,id:4},
  { path: '/dashboards', name: 'DashboardSimple', component: DashboardSimple ,id:4},
  { path: '/theme', name: 'Theme', component: Colors, exact: true ,id:0},
  { path: '/theme/colors', name: 'Colors', component: Colors ,id:0},
  { path: '/theme/typography', name: 'Typography', component: Typography ,id:0},
   
  { path: '/Food/Order/', name: 'SaleO', component: Order ,id:4},
  { path: '/Sale/Order/:id', name: 'SaleO', component: saleo ,id:4},
  { path: '/Sale/Order', name: 'SaleO', component: saleo ,id:4},
  { path: '/Sale/List', name: 'saleList', component: saleList ,id:4},
  
  { path: '/Item/New', name: 'ItemDef', component: ItemDef ,id:4},
  { path: '/Item/Edit/:id', name: 'ItemDef', component: ItemDef ,id:4},
  { path: '/Item/List', name: 'ItemDef', component: itemList ,id:4},
  
];

export default routes;
